import type { RouteRecordRaw } from 'vue-router';

import { wrapRuntimeImport } from '@/shared/helpers/async.helpers';
import { makePermissionMeta } from '@/shared/helpers/permissions.helpers';

export const AdminIntegrationsRoutes: RouteRecordRaw[] = [
    {
        path: '',
        component: wrapRuntimeImport(() => import('./screens/landing.vue')),
        meta: { admin: true }
    },
    {
        path: 'webhooks',
        component: wrapRuntimeImport(() => import('./screens/webhooks.vue')),
        meta: { admin: true, ...makePermissionMeta('sales') }
    },
    {
        path: 'webhooks/:id/deliveries',
        component: wrapRuntimeImport(() => import('./screens/webhooks/deliveries.vue')),
        meta: { admin: true, ...makePermissionMeta('sales') }
    }
];
